import api from './api';

export const paymentService = {
  async getKey() {
    const res = await api.get('/payments/key');
    return res.data.key;
  },

  async createOrder(amount, type, metadata = {}) {
    const res = await api.post('/payments/create-order', { amount, type, metadata });
    return res.data;
  },

  async verifyPayment(razorpay_order_id, razorpay_payment_id, razorpay_signature) {
    const res = await api.post('/payments/verify', {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
    });
    return res.data;
  },
};

export async function initRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(window.Razorpay);
    document.body.appendChild(script);
  });
}

export async function openPayment({
  amount,
  type = 'donation',
  metadata = {},
  onSuccess,
  onFailure,
  onClose,
}) {
  const Razorpay = await initRazorpay();

  const orderData = await paymentService.createOrder(amount, type, metadata);

  const options = {
    key: orderData.key,
    amount: orderData.amount,
    currency: orderData.currency,
    name: 'Sanatana Chronicles',
    description: type === 'donation' ? 'Daana - Offer to the Dharma' : 'Granth Bhandar - Sacred Books',
    image: '/om-icon.svg',
    order_id: orderData.orderId,
    handler: async function (response) {
      try {
        await paymentService.verifyPayment(
          response.razorpay_order_id,
          response.razorpay_payment_id,
          response.razorpay_signature
        );
        if (onSuccess) onSuccess(response);
      } catch (err) {
        if (onFailure) onFailure(err);
      }
    },
    prefill: {
      name: metadata.donor_name || '',
    },
    notes: {
      type,
      ...metadata,
    },
    theme: {
      color: '#d4a44a',
      backdrop_color: '#1a0e04',
    },
    modal: {
      ondismiss: function () {
        if (onClose) onClose();
      },
    },
  };

  const rzp = new Razorpay(options);
  rzp.on('payment.failed', function (response) {
    if (onFailure) onFailure(response);
  });
  rzp.open();
}